'use strict';

/** Tooltip / aria text for LV rows classified as edited (portal file out of sync with Lab Vantage). */
export const LAB_VANTAGE_EDITED_TOOLTIP =
	'File was changed since last uploaded to portal';
